import type { Trigger } from './types';

export const exitIntent: Trigger = (triggerName = 'exitIntent') => {
  const { documentElement } = document;

  return (activate) => {
    const listener = (e: MouseEvent) => {
      if (e.pageY < 0 || e.clientY < 0) {
        activate(triggerName);
      }
    };

    documentElement.addEventListener('mouseleave', listener, {
      passive: true
    });

    return () => {
      documentElement.removeEventListener('mouseleave', listener);
    };
  };
};
